import styled, { css } from 'styled-components';
import {
    colorBackground,
    headerHeight,
    mediaSm,
    transitionBase,
} from 'theme/theme-helper-selectors';
import { MobileWrap } from './mobile-wrap';

const collapseMixin = css`
    overflow: hidden;
    height: 0;

    ${MobileWrap} {
        max-height: 0;
    }
`;

const expandMixin = css`
    height: calc(100dvh - ${headerHeight});
`;

export const NavBarCollapse = styled.div<{ collapse: boolean }>`
    @media (${mediaSm}) {
        transition: ${transitionBase};
        background-color: ${colorBackground};

        ${({ collapse }) => (collapse ? collapseMixin : expandMixin)}
    }
`;
